export const navigateToExternalUrl = (url: string) => {
  window.location.replace(url);
};
